import { useUserStore } from '../state'
import { jwtDecode } from 'jwt-decode'

const useUserRoles = (roleNames = []) => {
	const { session } = useUserStore()

	if (!session?.access_token) return false

	try {
		const decoded = jwtDecode(session.access_token)

		const userRoles =
			decoded.user_role ||
			decoded.roles ||
			[]

		if (!Array.isArray(userRoles)) return false

		return userRoles.some(role => roleNames.includes(role))
	} catch {
		return false
	}
}

export default useUserRoles
